var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0011 74.1873C23.0011 45.8502 46.0741 23 74.407 23C102.74 23 125.813 45.8333 125.813 74.1873C125.813 86.2159 121.644 97.2774 114.664 106.012C105.032 118.108 90.3289 125.376 74.4059 125.376C58.483 125.376 43.7604 118.063 34.1406 106.012C27.1604 97.2785 23 86.2169 23 74.1873H23.0011Z",
    fill: "url(#paint0_linear_14429_27895)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7992 128.841C53.3595 127.61 52.7939 126.152 51.5574 125.594C50.321 125.036 48.8649 125.583 48.3045 126.814C47.7441 128.045 48.2854 129.512 49.5218 130.069C50.7583 130.627 52.2388 130.071 52.7992 128.84V128.841Z",
    fill: "url(#paint1_linear_14429_27895)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6024 132.491C66.959 131.708 66.5992 130.78 65.8127 130.425C65.0263 130.07 64.0987 130.418 63.7421 131.202C63.3855 131.985 63.7304 132.919 64.5169 133.274C65.3033 133.63 66.2458 133.276 66.6024 132.492V132.491Z",
    fill: "url(#paint2_linear_14429_27895)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8543 58.6788C21.2109 57.8957 20.8511 56.9678 20.0647 56.6127C19.2783 56.2576 18.3507 56.6053 17.9941 57.3895C17.6375 58.1726 17.9824 59.1068 18.7688 59.4619C19.5553 59.8169 20.4977 59.4629 20.8543 58.6798V58.6788Z",
    fill: "url(#paint3_linear_14429_27895)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3524 132.491C59.709 131.708 59.3492 130.78 58.5627 130.425C57.7763 130.07 56.8487 130.418 56.4921 131.202C56.1355 131.985 56.4804 132.919 57.2669 133.274C58.0533 133.63 58.9958 133.275 59.3524 132.492V132.491Z",
    fill: "url(#paint4_linear_14429_27895)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.877 43.4936C124.761 42.4685 124.629 40.9108 123.6 40.0305C122.57 39.1502 121.018 39.2675 120.134 40.2926C119.25 41.3177 119.356 42.8765 120.386 43.7578C121.415 44.6382 122.994 44.5187 123.878 43.4936H123.877Z",
    fill: "url(#paint5_linear_14429_27895)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.575 48.6649C129.138 48.0118 129.054 47.0216 128.399 46.4604C127.743 45.9003 126.756 45.9754 126.194 46.6274C125.631 47.2805 125.698 48.2718 126.354 48.833C127.01 49.3931 128.014 49.317 128.576 48.6649H128.575Z",
    fill: "url(#paint6_linear_14429_27895)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3403 41.0399C31.2244 40.0148 31.0928 38.457 30.0633 37.5767C29.0338 36.6964 27.4822 36.8137 26.5981 37.8388C25.714 38.8639 25.8201 40.4227 26.8496 41.3041C27.8791 42.1844 29.4573 42.065 30.3413 41.0399H30.3403Z",
    fill: "url(#paint7_linear_14429_27895)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8369 49.9358C25.0556 48.5226 24.8742 46.3752 23.455 45.1616C22.0358 43.9481 19.8968 44.1098 18.678 45.5229C17.4592 46.9361 17.6056 49.085 19.0248 50.3C20.444 51.5136 22.6196 51.3489 23.8383 49.9358H23.8369Z",
    fill: "url(#paint8_linear_14429_27895)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 74,
    r: 47.7,
    fill: "url(#paint9_linear_14429_27895)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.0002,
    cy: 73.9999,
    r: 34.56,
    fill: "url(#paint10_linear_14429_27895)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4441 90.39L54.1346 80.0912C51.5776 78.0239 51.1853 74.2755 53.2531 71.7187C55.3208 69.1618 59.0697 68.7692 61.6267 70.8365L70.3915 77.4516L87.0036 56.2147C89.116 53.6935 92.8708 53.3668 95.3922 55.4787C97.9135 57.5906 98.2401 61.345 96.1277 63.8661L75.7592 89.587C73.6711 92.0808 69.965 92.4274 67.4511 90.3886L67.4441 90.39Z",
    fill: "#3C4EF8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14429_27895",
    x1: 30.5,
    y1: 28.5,
    x2: 91,
    y2: 132.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEEF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14429_27895",
    x1: 50.5497,
    y1: 125.376,
    x2: 50.5497,
    y2: 130.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14429_27895",
    x1: 65.171,
    y1: 130.286,
    x2: 65.171,
    y2: 133.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14429_27895",
    x1: 19.4229,
    y1: 56.4735,
    x2: 19.4229,
    y2: 59.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14429_27895",
    x1: 57.921,
    y1: 130.286,
    x2: 57.921,
    y2: 133.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14429_27895",
    x1: 122,
    y1: 39.4399,
    x2: 122,
    y2: 44.3475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14429_27895",
    x1: 127.381,
    y1: 46.0848,
    x2: 127.381,
    y2: 49.2081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14429_27895",
    x1: 28.4638,
    y1: 36.9862,
    x2: 28.4638,
    y2: 41.8937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14429_27895",
    x1: 21.25,
    y1: 44.3475,
    x2: 21.25,
    y2: 51.1129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14429_27895",
    x1: 39.44,
    y1: 37.52,
    x2: 111.44,
    y2: 114.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6B9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE4FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14429_27895",
    x1: 50.0002,
    y1: 48.0799,
    x2: 95.1202,
    y2: 101.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.bca9f062b567ae81718790e41e6d5a6e.svg";
export { ForwardRef as ReactComponent };